{
  "accessed": "2026-09-12",
  "publicationDate": "2026-07-14",
  "sourceUrl": "https://www.gov.uk/government/statistics/large-businesses-payment-practices-and-performance-statistics-2025/large-businesses-payment-practices-and-performance-statistics-2025-commentary",
  "tables": {
    "1": [
      [
        "2018",
        35
      ],
      [
        "2019",
        34
      ],
      [
        "2020",
        34
      ],
      [
        "2021",
        33
      ],
      [
        "2022",
        33
      ],
      [
        "2023",
        32
      ],
      [
        "2024",
        32
      ],
      [
        "2025",
        32
      ]
    ],
    "2": [
      [
        "East Midlands",
        38
      ],
      [
        "East of England",
        33
      ],
      [
        "London",
        27
      ],
      [
        "North East",
        35
      ],
      [
        "North West",
        34
      ],
      [
        "Northern Ireland",
        33
      ],
      [
        "Scotland",
        32
      ],
      [
        "South East",
        32
      ],
      [
        "South West",
        31
      ],
      [
        "Wales",
        30
      ],
      [
        "West Midlands",
        38
      ],
      [
        "Yorkshire and The Humber",
        37
      ]
    ],
    "3": [
      [
        "A – Agriculture, forestry and fishing",
        32
      ],
      [
        "B – Mining and quarrying",
        31
      ],
      [
        "C – Manufacturing",
        45
      ],
      [
        "D – Electricity, gas, steam and air conditioning supply",
        25
      ],
      [
        "E – Water supply; sewerage, waste management and remediation activities",
        37
      ],
      [
        "F – Construction",
        33
      ],
      [
        "G – Wholesale and retail trade; repair of motor vehicles and motorcycles",
        37
      ],
      [
        "H – Transportation and storage",
        35
      ],
      [
        "I – Accommodation and food service activities",
        35
      ],
      [
        "J – Information and communication",
        29
      ],
      [
        "K – Financial and insurance activities",
        21
      ],
      [
        "L – Real estate activities",
        28
      ],
      [
        "M – Professional, scientific and technical activities",
        31
      ],
      [
        "N – Administrative and support service activities",
        27
      ],
      [
        "O – Public administration and defence; compulsory social security",
        27
      ],
      [
        "P – Education",
        25
      ],
      [
        "Q – Human health and social work activities",
        26
      ],
      [
        "R – Arts, entertainment and recreation",
        30
      ],
      [
        "S – Other service activities",
        31
      ]
    ],
    "4": [
      [
        "2018",
        25,
        "No data available"
      ],
      [
        "2019",
        23,
        "No data available"
      ],
      [
        "2020",
        23,
        "No data available"
      ],
      [
        "2021",
        20,
        "No data available"
      ],
      [
        "2022",
        20,
        "No data available"
      ],
      [
        "2023",
        18,
        "No data available"
      ],
      [
        "2024",
        16,
        "No data available"
      ],
      [
        "2025",
        15,
        14
      ]
    ],
    "5": [
      [
        "East Midlands",
        16,
        15
      ],
      [
        "East of England",
        15,
        14
      ],
      [
        "London",
        14,
        13
      ],
      [
        "North East",
        12,
        16
      ],
      [
        "North West",
        14,
        16
      ],
      [
        "Northern Ireland",
        14,
        11
      ],
      [
        "Scotland",
        15,
        14
      ],
      [
        "South East",
        15,
        13
      ],
      [
        "South West",
        16,
        15
      ],
      [
        "Wales",
        18,
        13
      ],
      [
        "West Midlands",
        19,
        18
      ],
      [
        "Yorkshire and The Humber",
        16,
        15
      ]
    ],
    "6": [
      [
        "A – Agriculture, forestry and fishing",
        15,
        15
      ],
      [
        "B – Mining and quarrying",
        12.5,
        11
      ],
      [
        "C – Manufacturing",
        21,
        21
      ],
      [
        "D – Electricity, gas, steam and air conditioning supply",
        11,
        8
      ],
      [
        "E – Water supply; sewerage, waste management and remediation activities",
        18.5,
        22
      ],
      [
        "F – Construction",
        14,
        13
      ],
      [
        "G – Wholesale and retail trade; repair of motor vehicles and motorcycles",
        15,
        11
      ],
      [
        "H – Transportation and storage",
        12,
        14
      ],
      [
        "I – Accommodation and food service activities",
        9,
        10
      ],
      [
        "J – Information and communication",
        15,
        16
      ],
      [
        "K – Financial and insurance activities",
        13,
        12
      ],
      [
        "L – Real estate activities",
        17,
        19
      ],
      [
        "M – Professional, scientific and technical activities",
        16,
        16
      ],
      [
        "N – Administrative and support service activities",
        12,
        11
      ],
      [
        "O – Public administration and defence; compulsory social security",
        14.5,
        14
      ],
      [
        "P – Education",
        16,
        16
      ],
      [
        "Q – Human health and social work activities",
        10,
        12
      ],
      [
        "R – Arts, entertainment and recreation",
        15,
        13
      ],
      [
        "S – Other service activities",
        12,
        12
      ]
    ],
    "7": [
      [
        2018,
        13175
      ],
      [
        2019,
        13177
      ],
      [
        2020,
        12371
      ],
      [
        2021,
        12130
      ],
      [
        2022,
        11830
      ],
      [
        2023,
        11918
      ],
      [
        2024,
        11954
      ],
      [
        2025,
        11178
      ]
    ]
  }
}
